import React from 'react'
import { Button, Card } from 'react-bootstrap';
import "./styles.scss"
import { BUSINESS_PLUS_COMPARISON_DATA } from './constants';
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { isNull } from 'lodash';
import { useNavigate } from 'react-router-dom';

const Description = ({ description }) => (
    <span className="ms-2 fv_pricing-table-content">
        {description?.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ))}
    </span>
)

const ComparisonTable = ({
    plusLoginPath = "/business-plus/login",
    primeLoginPath = "/business-prime-plus/login",
}) => {

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlObject = new URL(currentUrl);
    const queryParams = urlObject.search;

    return (
        <Card className='container p-0 mb-4 fv_pricing-card overflow-y-auto my-0 rounded-3 hide-scroller'>
            <table className="w-100 fv-pricing-table">
                <colgroup>
                    <col className='w-50' />
                    <col className='w-25' />
                    <col className='w-25' />
                </colgroup>
                <tbody>
                    <tr>
                        <th rowSpan={2}></th>
                        <th className='text-center fs-4 fv_colored-heading py-3'>Business Plus</th>
                        <th className='text-center fs-4 py-3'>Business Prime</th>
                    </tr>
                    <tr>
                        <td className='text-center fv_pricing-content px-3'>For businesses not providing financial services, including marketing agencies, consulting firms, technology companies, e-commerce businesses, holding companies, proprietary trading firms, and family offices.</td>
                        <td className='text-center fv_pricing-content px-3'>For non-banking financial institutions (NBFIs) holding licenses such as MSBs, VASPs, MSOs, EMIs, DLT frameworks, Funds, and similar, engaged in exchanges, OTC services, remittance and FX, brokerage, liquidity provision, and other financial activities.</td>
                    </tr>
                    {
                        BUSINESS_PLUS_COMPARISON_DATA?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className='fv_pricing-content fv_pricing-table-content ps-3'>{item.title}</td>
                                    <td className='text-center fv_pricing-content'>
                                        {isNull(item.bPlus.isValid) ? null : item.bPlus.isValid ? <FaCheck size={15} color='#11AF33' /> : <IoClose size={18} color='#C51010' />}
                                        {item.bPlus.description ? <Description description={item.bPlus?.description} /> : null}
                                    </td>
                                    <td className='text-center fv_pricing-content'>
                                        {isNull(item.bPrime.isValid) ? null : item.bPrime.isValid ? <FaCheck size={15} color='#11AF33' /> : <IoClose size={18} color='#C51010' />}
                                        {item.bPrime.description ? <Description description={item.bPrime?.description} /> : null}
                                    </td>
                                </tr>
                            )
                        })
                    }
                    <tr>
                        <td></td>
                        <td className='text-center cursor-pointer fv_comaparison-table-button p-2'>
                            <div onClick={() => { navigate(`${plusLoginPath}${queryParams}`) }} className='text-white  fs-5'>Get Business Plus</div>
                        </td>
                        <td className='text-center cursor-pointer bg-black p-2'>
                            <div onClick={() => { navigate(`${primeLoginPath}${queryParams}`) }} className='text-white  fs-5'>Get Business Prime</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Card>
    )
}

export default ComparisonTable;
